"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.joinString = function (delimiter) {
    return function joinFn() {
        var results = [];
        for (var index = 0; index < arguments.length; index++) {
            var item = arguments[index];
            if (!item && item !== 0)
                continue;
            var itemType = typeof item;
            if (itemType == 'string' || itemType == 'number') {
                results.push(item);
                continue;
            }
            if (Array.isArray(item) && item.length > 0) {
                var innerResult = joinFn.apply(null, item);
                if (innerResult) {
                    results.push(innerResult);
                }
            }
        }
        return results.join(delimiter);
    };
};
exports.default = exports.joinString;
exports.joinClassName = exports.joinString(' ');
//# sourceMappingURL=index.js.map